import {
  faCalendar,
  faClock,
} from "@fortawesome/free-regular-svg-icons";
import { faBarcode, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  orderListDetailApi,
  OrderspreparedAPI,
} from "../../Api/SupplierServices";
import { separate } from "../../Functions/NumberSeprator";
import Factor from "../Factor/Factor";
import LoadingComponet from "../LoadingComponet/LoadingComponet";
import Modal from "../Modal/Modal";
import Style from "../ReceivedOrders/ReceivedOrders.module.css";
import Timer from "../Timer/Timer";
const OrdersPrepared = () => {
  useEffect(() => {
    getOrderLists();
  }, []);
  let history = useHistory();
  const [purchased, setPurchased] = useState(false);
  const [orderList, setOrderList] = useState();
  const [orderListDetails, setOrderListDetails] = useState();

  const getOrderLists = async () => {
    const data = await OrderspreparedAPI();
    setOrderList(data.orders);
  };
  const getOrderListsDetail = async (id) => {
    const data = await orderListDetailApi(id);
    setOrderListDetails(data);
  };

  const FactorListHandler = (id) => {
    setPurchased(true);
    getOrderListsDetail(id);
  };
  const deliverLocation = (orderId) => {
    history.push("/live", orderId);
  };
  let loadinghandler = null;
  if (orderList === undefined) {
    loadinghandler = <LoadingComponet />;
  } else if (orderList.length === 0) {
    loadinghandler = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
        </div>
      </div>
    );
  } else {
    loadinghandler = orderList.map((item, index) => {
      return (
        <ul key={index} className={Style.EachPart__ul}>
          {/* <li className={Style.EachPart__li}><FontAwesomeIcon icon={faUser}/>{item.customer}</li> */}
          <li className={Style.EachPart__li__Date}>
            <div>
              <FontAwesomeIcon icon={faCalendar} />
              {item.date.split(" ")[0]}
            </div>
            <div>
              <FontAwesomeIcon icon={faClock} />
              {item.date.split(" ")[1]}
            </div>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faBarcode} />
            کد پیگیری: <span>{item.id}</span>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faMoneyBillWave} /> مبلغ کل:{" "}
            <p>{separate(item.cart)} تومان</p>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faMoneyBillWave} /> کمیسیون:{" "}
            <p>{separate(item.cart_fee)} تومان</p>
          </li>
          <li className={Style.deliveryCode}>
             کد پیک :{" "}
            {item.delivery_code}
          </li>
          <li className={Style.BtnHolder}>
            <Timer Time={item.prepare_remaining_time} />
            {item.status === "1" ? (
              <h2 className={Style.deliverWait}>در انتظار تایید پیک</h2>
            ) : (
              <button
                className={Style.deliverLoc}
                onClick={() => deliverLocation(item.id)}
              >
                مکان پیک
              </button>
            )}
            <button
              className={Style.borderRed}
              onClick={() => FactorListHandler(item.id)}
            >
              لیست سفارش
            </button>
          </li>
        </ul>
      );
    });
  }

  return (
    <ul className={Style.ComponentHolder}>
      <Modal
        show={purchased}
        modalClose={() => setPurchased(false)}
        translate={40}
      >
        <Factor data={orderListDetails} />
      </Modal>
      <li className={Style.EachPart}>{loadinghandler}</li>
    </ul>
  );
};

export default OrdersPrepared;
